class ShareButton extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector('button'),
      shareButton: this.querySelector('[data-share-button]'),
      shareSummary: this.querySelector('summary'),
      shareDetails: this.querySelector('details'),
      shareInput: this.querySelector('input'),
      shareCopy: this.querySelector('[data-copy-button]'),
      shareMessage: this.querySelector('[data-share-message]')
    };

    this.urlInput = this.elements.shareInput;

    if (navigator.share) {
      this.elements.button.classList.remove('hidden');
      this.elements.shareDetails.classList.add('hidden');
      this.elements.button.addEventListener('click', () => {
        navigator.share({
          title: document.title,
          url: this.urlInput.value
        });
      });
    } else {
      this.elements.shareDetails.classList.remove('hidden');
      this.elements.button.classList.add('hidden');
      this.elements.shareCopy.addEventListener('click', this.copyToClipboard.bind(this));
    }

    this.elements.shareSummary?.addEventListener('click', (event) => {
      event.currentTarget.parentNode.toggleAttribute('open');
    });

    this.elements.shareDetails?.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle(event) {
    if (!event.currentTarget.open) return;
    const shareSummary = event.currentTarget.querySelector('summary');
    const focusableElements = event.currentTarget.querySelectorAll('button, [href], input');
    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];

    shareSummary.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.urlInput.value).then(() => {
      this.elements.shareMessage.classList.remove('hidden');
      setTimeout(() => {
        this.elements.shareMessage.classList.add('hidden');
      }, 2000);
    });
  }
}

customElements.define('share-button', ShareButton);
